import axios from 'axios';
// import { window.API_BASE_URL } from '../config.js';
import Cookies from 'universal-cookie'

const initialState = {
    flowList: [],
    flowMenu: [],
    flowConfiguration: null,
    flowReport: [],
};

// Action Types
const GET_FLOW = 'GET_FLOW';
const GET_FLOW_MENU = 'GET_FLOW_MENU';
const UPDATE_FLOW = 'UPDATE_FLOW';
const POST_FLOW = 'POST_FLOW';
const DELETE_FLOW = 'DELETE_FLOW';
const COMPILE_FLOW = 'COMPILE_FLOW';
const GET_FLOW_CONFIGURATION = 'GET_FLOW_CONFIGURATION';
const UPDATE_FLOW_CONFIGURATION = 'UPDATE_FLOW_CONFIGURATION';
const GET_FLOW_REPORT = 'GET_FLOW_REPORT';

// Reducer
export default function flowReducer(state = initialState, action) {
    switch (action.type) {
        case GET_FLOW:
            return { ...state, flowList: action.payload }; // Actualiza flowList con nuevos datos de flujo
        case UPDATE_FLOW:
            const { id, data } = action.payload;

            // Actualizar el flujo según el id o añadir uno nuevo si no existe
            const updatedFlows = state.flowList.some(flow => flow.id === id)
                ? state.flowList.map(flow =>
                    flow.id === id ? { ...flow, ...data } : flow
                  )
                : [...state.flowList, { id, ...data }];

            return { ...state, flowList: updatedFlows };
        case GET_FLOW_MENU:
            return { ...state, flowMenu: action.payload };
        case POST_FLOW:
            return { ...state, flowList: [...state.flowList, action.payload] }; // Añade un nuevo flujo a flowList
        case DELETE_FLOW:
            return { ...state, flowList: state.flowList.filter(flow => flow.id !== action.payload.id) }; // Elimina el flujo por id de flowList
        case GET_FLOW_CONFIGURATION:
            return { ...state, flowConfiguration: action.payload }; // Actualiza la configuración del flujo
        case UPDATE_FLOW_CONFIGURATION:
            return { ...state, flowConfiguration: action.payload };
        case COMPILE_FLOW:
        case GET_FLOW_REPORT:
            return { ...state, flowReport: action.payload }; // Retorna el estado actual sin cambios
        default:
            return state;
    }
}

// Action Creators
export const UpdateFlow = (id, data) => ({
    type: UPDATE_FLOW,
    payload: { id, data },
});

export const GetFlows = (flows) => ({
    type: GET_FLOW,
    payload: flows,
});

export const GetFlowsMenu = (flows) => ({
    type: GET_FLOW_MENU,
    payload: flows,
});

export const PostFlow = (flow) => ({
    type: POST_FLOW,
    payload: flow,
});

export const DeleteFlow = (id) => ({
    type: DELETE_FLOW,
    payload: { id },
});

export const CompileFlow = (id) => ({
    type: COMPILE_FLOW,
    payload: { id },
});

export const GetFlowConfiguration = (configuration) => ({
    type: GET_FLOW_CONFIGURATION,
    payload: configuration,
});

export const UpdateFlowConfiguration = (configuration) => ({
    type: UPDATE_FLOW_CONFIGURATION,
    payload: configuration,
});

export const FetchReport = (data) => ({
    type: GET_FLOW_REPORT,
    payload: data,
});

// API Integration Functions
export const fetchFlowsFromAPI = (DATA) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        var response
        if (DATA === "0") {
            response = await axios.get(window.API_BASE_URL+'/Flow/Messages',{headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
        } else {
            response = await axios.get(window.API_BASE_URL+'/Flow/Messages/BusinessLine/'+DATA,{headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
        }
        //const response = await axios.get(window.API_BASE_URL+'/Flow/Messages'); // GET request
        const data = await response.data;
        dispatch(GetFlows(data));
    } catch (error) {
        console.error('Error fetching flows:', error);
    }
};

// Trae el detalle de un flow (incluye Content). Los listados retornan Content=null
// para mantener la respuesta liviana; este endpoint hidrata el flow seleccionado.
export const fetchFlowDetailFromAPI = (id) => async () => {
    try {
        const cookies = new Cookies();
        const response = await axios.get(
            window.API_BASE_URL + '/Flow/Messages/Detail/' + id,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching flow detail:', error);
        throw error;
    }
};

// Genera un borrador de flujo desde un prompt (IA). Devuelve { content, warnings }.
export const generateFlowFromPrompt = (prompt, businessLineId) => async () => {
    const cookies = new Cookies();
    const response = await axios.post(
        window.API_BASE_URL + '/Flow/Generate',
        { prompt, businessLineId },
        { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
    );
    return response.data; // { content: "<reactflow json>", warnings: [...] }
};

export const createFlowInAPI = (flow) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.post(window.API_BASE_URL+'/Flow/Messages',
           flow,
           {headers: {'Authorization': `Bearer ${cookies.get('token')}`}}
        );
        const data = await response.data;
        dispatch(PostFlow(data));
        return data;
    } catch (error) {
        console.error('Error creating flow:', error);
        throw error;
    }
};

export const updateFlowInAPI = (flow) => async (dispatch) => {
    try {
        const cookies = new Cookies()
        const userId = cookies.get('userId')
        flow.userId = Number(userId)
        
        const response = await axios.put(window.API_BASE_URL+'/Flow/Messages',
           flow,
           {headers: {'Authorization': `Bearer ${cookies.get('token')}`}}
        );
        const data = await response.data;
        dispatch(PostFlow(data));
    } catch (error) {
        console.error('Error creating flow:', error);
    }
};

export const deleteFlowFromAPI = (id) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        await fetch(`/api/Flow/Messages/${id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${cookies.get('token')}` },
        });
        dispatch(DeleteFlow(id));
    } catch (error) {
        console.error('Error deleting flow:', error);
    }
};

export const compileFlowAPI = (id) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.get(window.API_BASE_URL+'/Flow/Messages/Compile/'+id,
            {headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
        const data = await response.data;
    } catch (error) {
        console.error('Error creating flow:', error);
    }
};

export const fetchFlowsAnyConversationFromAPI = (DATA) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        var response = await axios.get(window.API_BASE_URL+'/Flow/MessagesConversation',{headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
       
        //const response = await axios.get(window.API_BASE_URL+'/Flow/Messages'); // GET request
        const data = await response.data;
        dispatch(GetFlowsMenu(data));
    } catch (error) {
        console.error('Error fetching flows:', error);
    }
};

export const getFlowConfiguration = (flowId) => async (dispatch) => {
    try {
        const cookies = new Cookies()

        const response = await axios.get(window.API_BASE_URL+'/Flow/Messages/Configuration/'+flowId,
            {headers: {'Authorization': `Bearer ${cookies.get('token')}`}});
        const data = await response.data;
        dispatch(GetFlowConfiguration(data));
    } catch (error) {
        console.error('Error fetching flow configuration:', error);
    }
}

export const getFlowReport = (flowId,startDate,endDate) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const body = {
            startDate: startDate,
            endDate: endDate,
            flowMessageId: flowId
        };
        const response = await axios.post(
            window.API_BASE_URL + '/Flow/Report/Conciliation/',
            body,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        const data = await response.data;
        dispatch(FetchReport(data));
    } catch (error) {
        console.error('Error fetching flow report:', error);
    }
}

export const getFlowReportExcel = (flowId,startDate,endDate) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        const body = {
            startDate: startDate,
            endDate: endDate,
            flowMessageId: flowId
        };
        const response = await axios.post(
            window.API_BASE_URL + '/Flow/Report/ConciliationExcel/',
            body,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` },
                responseType: 'blob'
            }
            
        );
         // Crear enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `ConciliationReport_${startDate}/${endDate}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error('Error fetching flow report:', error);
    }
}

export const updateFlowConfiguration = (flowId, configuration) => async (dispatch) => {
    try {
        const cookies = new Cookies();
        // Endpoint esperado: /Flow/Messages/Configuration/{flowId}
        const response = await axios.put(
            window.API_BASE_URL + '/Flow/Messages/Configuration/' + flowId,
            configuration,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        const data = await response.data;
        dispatch(UpdateFlowConfiguration(data));
        return data;
    } catch (error) {
        console.error('Error updating flow configuration:', error);
        throw error;
    }
}

export const createFlowVersionInAPI = (flowVersion) => async () => {
    try {
        const cookies = new Cookies();
        const userId = cookies.get('userId');
        flowVersion.userId = Number(userId);

        // Endpoint esperado (backend): /Flow/Versions o similar
        const response = await axios.post(
            window.API_BASE_URL + '/Flow/Versions',
            flowVersion,
            { headers: { 'Authorization': `Bearer ${cookies.get('token')}` } }
        );
        return await response.data;
    } catch (error) {
        console.error('Error creating flow version:', error);
        throw error;
    }
};
